export default __webpack_public_path__ + "b5d546ecb0fcdb0aa2319161a7c41374.png";